"use strict";var e=require("../Coerce/asType.cjs"),r=require("./camelCase.cjs");exports.strictCamelCase=function(s){return e.asType(r.camelCase(s))};
//# sourceMappingURL=strictCamelCase.cjs.map
